export function topMenu () {
    const topMenu = document.querySelector(".top-menu");
    const menuItems = topMenu.querySelectorAll("li");
    [...menuItems].forEach((item) => {
        if(item.classList.contains("hide-menu")) {
            topMenu.style.display = "none";
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/topMenu.js